document.querySelectorAll('.kitteen-ribbon').forEach(ribbon => {
  const button = ribbon.querySelector('.kitteen-ribbon__toggle');
  if (!button) return;
  button.addEventListener('click', () => {
    const paused = ribbon.dataset.paused !== 'true';
    ribbon.dataset.paused = String(paused);
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? 'Reprendre le défilement du bandeau' : 'Mettre le bandeau en pause');
  });
});
